import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ADMIN_ROLES = new Set(['ADMIN', 'CEO']);

/**
 * Wraps a route so only ADMIN or CEO users can render it. Renders Navigate to
 * /dashboard for any signed-in non-admin user, and lets the existing
 * ProtectedRoute upstream handle unauthenticated users.
 */
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/signin" replace />;
  if (!ADMIN_ROLES.has(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
